export const onboardingUserDetails = {
  name: "user",
  email: "user@gmail.com",
};

export const roles = [
  "Head of Procurement/Operations",
  "Head of Finance/CFO",
  "Procurement Manager",
  "Finance Manager",
  "Production Planner",
  "Logistics Manager",
];

export const relevantAutomations = [
  {
    id:1,
    title: "Follow-up request",
    description:
      "Follow up with suppliers for the latest delivery date every week.",
    category: "FOLLOW-UPS +2",
    solves: 2,
    enabled: false,
  },
  {
    id:2,
    title: "Outstanding balances report",
    description:
      "Follow up with suppliers for the latest delivery date every week.",
    category: "ANALYTICS & REPORTING +2",
    solves: 3,
    enabled: false,
  },
  {
    id:3,
    title: "Outstanding balances report",
    description:
      "Follow up with suppliers for the latest delivery date every week.",
    category: "ANALYTICS & REPORTING +2",
    solves: 3,
    enabled: false,
  },
  {
    id:4,
    title: "Follow-up request",
    description:
      "Follow up with suppliers for the latest delivery date every week.",
    category: "FOLLOW-UPS +2",
    solves: 2,
    enabled: false,
  },
];

export const customiseAutomation = {
  title: "Customise automation [Automation comes title here]",
  customParameters: [
    "Lorem ipsum dolor sit amet",
    "Consectetur adipiscing",
    "Labore et dolore",
    "Ut enim ad minim veniam",
  ],
};

export const onboardingStatusSteps = [
  "Name and email address",
  "Job role and responsibilities",
  "Key challenges",
  "Proffered automations",
  "Single sign-on",
];

export const roleBasedDataMappings = {
  "Procurement Manager": {
    role: "Procurement Manager",
    objectives: [
      {
        checked: false,
        text: "Selecting and managing suppliers to ensure that materials and services are of high quality, delivered on time, and competitively priced.",
      },
      {
        checked: false,
        text: "Negotiating contracts that provide the best value for the company while maintaining strong supplier relationships.",
      },
    ],
    challenges: [
      {
        checked: false,
        text: "Managing supplier performance and addressing issues like late deliveries or non-compliance.",
      },
      {
        checked: false,
        text: "Adapting to fluctuations in demand and supply availability.",
      },
    ],
    automations: [
      {
        id:1,
        category: "Order Management",
        title: "Order Confirmations",
        description: "Follow up with suppliers to obtain order confirmations within a specified timeframe.",
        solves: 2,
        enabled: true,
      },
      {
        id:2,
        category: "Order Management",
        title: "Unconfirmed Orders Alert",
        description: "Notify relevant stakeholders if orders are not confirmed within 48 hours.",
        solves: 2,
        enabled: false,
      },
      {
        id:3,
        category: "Order Management",
        title: "PO Revisions Alert",
        description: "Send an alert on Microsoft Teams whenever there are revisions to purchase orders.",
        solves: 2,
        enabled: true,
      },
      {
        id:4,
        category: "Order Management",
        title: "PO Price Change Alert",
        description: "Notify relevant stakeholders if there is a change in the purchase order price.",
        solves: 2,
        enabled: false,
      },
      {
        id:5,
        category: "Supplier Follow-Ups",
        title: "Automated Document Follow-Up",
        description: "Automatically track and remind suppliers of any missing documents.",
        solves: 2,
        enabled: true,
      },
      {
        id:6,
        category: "Supplier Follow-Ups",
        title: "Request Shipping Documents",
        description: "Remind suppliers to provide required documents before every milestone.",
        solves: 2,
        enabled: true,
      },
      {
        id:7,
        category: "Document Management",
        title: "Missing Document Alerts",
        description: "Provide real-time notifications to highlight any missing documents.",
        solves: 2,
        enabled: false,
      },
      {
        id:8,
        category: "Document Management",
        title: "Document Matching",
        description: "Automatically compare and verify documents to identify any discrepancies.",
        solves: 2,
        enabled: false,
      },
      {
        id:9,
        category: "Document Management",
        title: "Discrepancy Alert System",
        description: "Issue immediate alerts for any inconsistencies or mismatches detected between related documents.",
        solves: 2,
        enabled: false,
      },
      {
        id:10,
        category: "Risk Management",
        title: "Shipment/Container/Courier Tracking",
        description: "Track container and shipment status and send alerts if there are delays or risks.",
        solves: 2,
        enabled: false,
      }
    ]
  },
  "Production Planner": {
    role: "Production Planner",
    objectives: [
      {
        checked: false,
        text: "Implementing continuous improvement initiatives to enhance supply chain efficiency and reduce waste.",
      },
      {
        checked: false,
        text: "Optimizing inventory levels to balance the need for availability with cost-efficiency.",
      },
    ],
    challenges: [
      {
        checked: false,
        text: "Dealing with production delays caused by equipment failures, material shortages, or other disruptions.",
      },
      {
        checked: false,
        text: "Responding to changes in customer demand that impact production schedules and inventory levels.",
      },
    ],
    automations: [
      {
        id:1,
        category: "Inventory & Demand Planning",
        title: "Stock Out Alerts",
        description: "Alert when stock levels drop below predefined thresholds.",
        solves: 2,
        enabled: false,
      },
      {
        id:2,
        category: "Inventory & Demand Planning",
        title: "Inventory Replenishment Suggestions",
        description: "Automated report on suggestions for reorder quantities based on historical data and current stock levels.",
        solves: 2,
        enabled: false,
      },
      {
        id:3,
        category: "Inventory & Demand Planning",
        title: "New Order Placement Alerts",
        description: "Notify when new orders need to be placed specifying quantities and dates.",
        solves: 2,
        enabled: false,
      },
      {
        id:4,
        category: "Cross-Departmental Coordination",
        title: "Daily Delivery Report",
        description: "Provide the warehousing team with a daily report on incoming deliveries.",
        solves: 2,
        enabled: false,
      }
    ]
  },
  "Logistics Manager": {
    role: "Logistics Manager",
    objectives: [
      {
        checked: false,
        text: "Ensuring the timely and efficient delivery of goods to meet production and customer needs.",
      },
      {
        checked: false,
        text: "Mitigating risks related to transportation and logistics delays.",
      },
    ],
    challenges: [
      {
        checked: false,
        text: "Managing logistics delays caused by transportation issues, regulatory challenges, or other factors.",
      },
      {
        checked: false,
        text: "Adapting to changes in transportation availability, fuel costs, and other logistics variables.",
      },
    ],
    automations: [
      {
        id:1,
        category: "Order Management",
        title: "Purchase Order Delay Alerts",
        description: "Notify relevant teams when there are changes in delivery dates due to external factors like port congestion or ESG risks.",
        solves: 2,
        enabled: false,
      },
      {
        id:2,
        category: "Supplier Follow-Ups",
        title: "Weekly Delivery Updates",
        description: "Contact suppliers weekly to get the most up-to-date delivery dates.",
        solves: 2,
        enabled: false,
      },
      {
        id:3,
        category: "Risk Management",
        title: "Port Risk Alert",
        description: "Notify stakeholders if a port is identified as at risk.",
        solves: 2,
        enabled: false,
      },
      {
        id:4,
        category: "Risk Management",
        title: "Port Congestion Alert",
        description: "Alert if port congestion increases by 24 hours.",
        solves: 2,
        enabled: false,
      }
    ]
  },
  "Finance Manager": {
    role: "Finance Manager",
    objectives: [
      {
        checked: false,
        text: "Ensuring the financial stability of the supply chain by managing costs, investments, and financial risks effectively.",
      },
      {
        checked: false,
        text: "Aligning supply chain financial planning with the company's broader financial goals and strategies.",
      },
    ],
    challenges: [
      {
        checked: false,
        text: "Managing the financial impact of supply chain disruptions or unexpected events.",
      },
      {
        checked: false,
        text: "Mitigating the impact of currency fluctuations, price volatility, and other financial risks.",
      },
    ],
    automations: [
      {
        id:1,
        category: "Inventory & Demand Planning",
        title: "Reducing Stagnant Inventory Alerts",
        description: "Send automated alerts when inventory levels exceed predefined Weeks on Hand (WoH) thresholds.",
        solves: 2,
        enabled: false,
      },
      {
        id:2,
        category: "Financial & Spend Management",
        title: "Match Invoices to POs and GRNs",
        description: "Automatically match invoices, purchase orders, and goods received notes to ensure consistency.",
        solves: 2,
        enabled: false,
      },
      {
        id:3,
        category: "Financial & Spend Management",
        title: "Payment Forecasting Report",
        description: "Generate weekly payment forecast reports.",
        solves: 2,
        enabled: false,
      },
      {
        id:4,
        category: "Financial & Spend Management",
        title: "Monthly Spend Reports",
        description: "Produce a monthly report on total spend with each supplier, including materials and country-specific expenditures.",
        solves: 2,
        enabled: false,
      },
      {
        id:5,
        category: "Financial & Spend Management",
        title: "Working Capital Reports",
        description: "Generate weekly reports on working capital and highlight areas for improvement.",
        solves: 2,
        enabled: false,
      },
      {
        id:6,
        category: "Financial & Spend Management",
        title: "Sourcing Cost Reports",
        description: "Generate weekly reports on sourcing costs and highlight areas for improvement.",
        solves: 2,
        enabled: false,
      },
      {
        id:7,
        category: "Risk Management",
        title: "Supplier Risk Alerts",
        description: "Notify stakeholders of expired supplier certifications, NDAs, and contracts.",
        solves: 2,
        enabled: false,
      }
    ]
  },
  "Head of Finance/CFO": {
    role: "Head of Finance/CFO",
    objectives: [
      {
        checked: false,
        text: "Ensuring the financial stability of the supply chain by managing costs, investments, and financial risks effectively.",
      },
      {
        checked: false,
        text: "Aligning supply chain financial planning with the company's broader financial goals and strategies.",
      },
    ],
    challenges: [
      {
        checked: false,
        text: "Managing the financial impact of supply chain disruptions or unexpected events.",
      },
      {
        checked: false,
        text: "Mitigating the impact of currency fluctuations, price volatility, and other financial risks.",
      },
    ],
    automations: [
      {
        id:1,
        category: "Inventory & Demand Planning",
        title: "Reducing Stagnant Inventory Alerts",
        description: "Send automated alerts when inventory levels exceed predefined Weeks on Hand (WoH) thresholds.",
        solves: 2,
        enabled: false,
      },
      {
        id:2,
        category: "Financial & Spend Management",
        title: "Match Invoices to POs and GRNs",
        description: "Automatically match invoices, purchase orders, and goods received notes to ensure consistency.",
        solves: 2,
        enabled: false,
      },
      {
        id:3,
        category: "Financial & Spend Management",
        title: "Payment Forecasting Report",
        description: "Generate weekly payment forecast reports.",
        solves: 2,
        enabled: false,
      },
      {
        id:4,
        category: "Financial & Spend Management",
        title: "Monthly Spend Reports",
        description: "Produce a monthly report on total spend with each supplier, including materials and country-specific expenditures.",
        solves: 2,
        enabled: false,
      },
      {
        id:5,
        category: "Financial & Spend Management",
        title: "Working Capital Reports",
        description: "Generate weekly reports on working capital and highlight areas for improvement.",
        solves: 2,
        enabled: false,
      },
      {
        id:6,
        category: "Financial & Spend Management",
        title: "Sourcing Cost Reports",
        description: "Generate weekly reports on sourcing costs and highlight areas for improvement.",
        solves: 2,
        enabled: false,
      },
      {
        id:7,
        category: "Risk Management",
        title: "Supplier Risk Alerts",
        description: "Notify stakeholders of expired supplier certifications, NDAs, and contracts.",
        solves: 2,
        enabled: false,
      }
    ]
  },
  "Head of Procurement/Operations": {
    role: "Head of Procurement/Operations",
    objectives: [
      {
        checked: false,
        text: "Ensuring seamless coordination across procurement, production, and logistics to optimize overall supply chain performance.",
      },
      {
        checked: false,
        text: "Mitigating risks across the supply chain, including supplier disruptions, economic changes, and regulatory shifts.",
      },
    ],
    challenges: [
      {
        checked: false,
        text: "Balancing cost efficiency with the need for quality in supplier management.",
      },
      {
        checked: false,
        text: "Mitigating risks related to supply chain disruptions, including geopolitical events, natural disasters, and economic downturns.",
      },
    ],
    automations: [
      {
        id:1,
        category: "Compliance Checks",
        title: "Expired Certifications/Contracts Alert",
        description: "Notify stakeholders of expired supplier certifications, NDAs, and contracts.",
        solves: 2,
        enabled: false,
      },
      {
        id:2,
        category: "Risk Management",
        title: "Facility and Single Source Risk Alerts",
        description: "Generate alerts and reports related to risks associated with supplier facilities and single-source materials.",
        solves: 2,
        enabled: false,
      },
      {
        id:3,
        category: "Risk Management",
        title: "Automated Risk Monitoring and Alerts",
        description: "Continuously monitor risk factors, providing real-time insights and alerts into supplier risk profiles.",
        solves: 2,
        enabled: false,
      },
      {
        id:4,
        category: "Reporting & Analytics",
        title: "Supplier Performance Report",
        description: "Generate weekly reports on supplier performance.",
        solves: 2,
        enabled: false,
      }
    ]
  },
  "other": {
    role: "other",
    objectives: [
      {
        checked: false,
        text: "Ensuring seamless coordination across procurement, production, and logistics to optimize overall supply chain performance.",
      },
      {
        checked: false,
        text: "Mitigating risks across the supply chain, including supplier disruptions, economic changes, and regulatory shifts.",
      },
      {
        checked: false,
        text: "Managing supplier relationships to balance cost, quality, and reliability.",
      },
      {
        checked: false,
        text: "Optimizing inventory levels to balance the need for availability with cost-efficiency.",
      },
    ],
    challenges: [
      {
        checked: false,
        text: "Adapting to fluctuations in demand and supply availability.",
      },
      {
        checked: false,
        text: "Managing supplier performance and addressing issues like late deliveries or non-compliance.",
      },
      {
        checked: false,
        text: "Mitigating risks related to supply chain disruptions, including geopolitical events, natural disasters, and economic downturns.",
      },
      {
        checked: false,
        text: "Managing logistics delays caused by transportation issues, regulatory challenges, or other factors.",
      },
    ],
    automations: [
      {
        id:1,
        category: "Order Management",
        title: "Order Confirmations",
        description: "Follow up with suppliers to obtain order confirmations within a specified timeframe.",
        solves: 2,
        enabled: false,
      },
      {
        id:2,
        category: "Supplier Follow-Ups",
        title: "Automated Document Follow-Up",
        description: "Automatically track and remind suppliers of any missing documents.",
        solves: 2,
        enabled: false,
      },
      {
        id:3,
        category: "Risk Management",
        title: "Shipment/Container/Courier Tracking",
        description: "Track container and shipment status and send alerts if there are delays or risks.",
        solves: 2,
        enabled: false,
      },
      {
        id:4,
        category: "Inventory & Demand Planning",
        title: "Stock Out Alerts",
        description: "Alert when stock levels drop below predefined thresholds.",
        solves: 2,
        enabled: false,
      },
      {
        id:5,
        category: "Financial & Spend Management",
        title: "Match Invoices to POs and GRNs",
        description: "Automatically match invoices, purchase orders, and goods received notes to ensure consistency.",
        solves: 2,
        enabled: false,
      },
      {
        id:6,
        category: "Risk Management",
        title: "Supplier Risk Alerts",
        description: "Notify stakeholders of expired supplier certifications, NDAs, and contracts.",
        solves: 2,
        enabled: false,
      }
    ]
  }
};